// extracted by mini-css-extract-plugin
module.exports = {"needUpdateStore":"_2WEKG","title":"_3Jgvy","dec":"_2HUuD","stores":"_2PmpK","gotIt":"HiZZ9","gotItButton":"_2PlOA"};